import { render, staticRenderFns } from "./ShopDefaultHeroSection.vue?vue&type=template&id=38cd804b&scoped=true&"
import script from "./ShopDefaultHeroSection.vue?vue&type=script&lang=js&"
export * from "./ShopDefaultHeroSection.vue?vue&type=script&lang=js&"
import style0 from "./ShopDefaultHeroSection.vue?vue&type=style&index=0&id=38cd804b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cd804b",
  null
  
)

export default component.exports